import { getGtmData } from '..';

const statements = () => ({
  onStatementPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/statements/home',
    //   title: 'PFM - Online Investments - Statements - Home',
    //   cd24: getGtmData('cd24'),
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen',
    // });
  },
  onClickMyHoldingsButton: () => {
  //   recordEventWrapper({
  //     event: 'event_PFM_on_click_event',
  //     category: 'PFM',
  //     action: 'Online Investments',
  //     label: 'Statements - Landing Screen - My Holdings',
  //   });
  // },
  // onClickTransactionButton: () => {
  //   recordEventWrapper({
  //     event: 'event_PFM_on_click_event',
  //     category: 'PFM',
  //     action: 'Online Investments',
  //     label: 'Statements - Landing Screen - Transactions',
  //   });
  },
  onSelectLatestHoldingStatement: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Latest Holding Statement',
    // });
  },
  onSelectTransactionStatement: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Transaction Statement',
    // });
  },
  onSelectCapitalGainAndLoss: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Capital Gain or Loss Statement',
    // });
  },
  onSelectDividendStatements: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Dividend Statement',
    // });
  },
  onClickBackButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Back',
    // });
  },
  onClickDownloadPDF: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Download PDF',
    // });
  },
  onClickEmailPDF: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Statements - Landing Screen - Email',
    // });
  },
});

export default statements;
